module.exports = __webpack_public_path__ + "static/media/half-logo.3f6b89ac.svg";